import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { SideNavSection } from '../../types'

const SideNav = ({
  sections,
  locationPathname,
}: {
  sections: SideNavSection[] | undefined
  locationPathname: string
}) => (
  <nav className="space-y-4">
    {sections?.map((section) => (
      <div key={section.title}>
        <p className="ml-2 text-sm font-medium text-gray-500">{section.title}</p>
        <ul className="mt-1 space-y-1">
          {section.links.map((link) => {
            const active = locationPathname.includes(link.to)
            return (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={classNames(
                    'w-full hover:text-gray-900 hover:bg-gray-200 group rounded-md px-3 py-2 flex items-center text-sm',
                    active ? 'bg-gray-200 text-gray-900' : 'text-gray-800'
                  )}
                >
                  <link.icon
                    className={classNames(
                      'group-hover:text-gray-600 flex-shrink-0 -ml-1 mr-3 h-6 w-6',
                      active ? 'text-gray-600' : 'text-gray-400'
                    )}
                    aria-hidden="true"
                  />
                  {link.title}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    ))}
  </nav>
)

export default SideNav
